(function () {
  'use strict';

  function textNode(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = text == null ? '' : String(text);
    return node;
  }

  function formatDate(value) {
    var date = new Date(value);
    return Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: 'numeric' }).format(date);
  }

  function safeMediaUrl(value) {
    try {
      var url = new URL(value);
      return url.protocol === 'https:' ? url.toString() : null;
    } catch (error) {
      return null;
    }
  }

  function createReviewMeta(review) {
    var meta = document.createElement('div');
    meta.className = 'bb-review-card__meta';
    var identity = document.createElement('div');
    identity.className = 'bb-review-card__identity';
    var reviewerName = review.reviewerName || 'Customer';
    var avatar = textNode('span', 'bb-review-card__avatar', reviewerName.trim().charAt(0).toUpperCase() || 'C');
    avatar.setAttribute('aria-hidden', 'true');
    identity.appendChild(avatar);
    identity.appendChild(textNode('strong', '', reviewerName));
    if (review.verifiedPurchase) identity.appendChild(textNode('span', 'bb-review-card__verified', 'Verified buyer'));
    meta.appendChild(identity);

    var rating = document.createElement('div');
    rating.className = 'bb-review-card__rating';
    var stars = textNode('span', 'bb-review-card__stars', '★'.repeat(Number(review.rating) || 0) + '☆'.repeat(5 - (Number(review.rating) || 0)));
    stars.setAttribute('aria-label', String(review.rating) + ' out of 5 stars');
    rating.appendChild(stars);
    rating.appendChild(textNode('time', '', formatDate(review.publishedAt)));
    meta.appendChild(rating);
    return meta;
  }

  function createReviewCard(review) {
    var card = document.createElement('article');
    card.className = 'bb-review-card';
    card.appendChild(createReviewMeta(review));
    if (review.title) card.appendChild(textNode('h3', '', review.title));
    card.appendChild(textNode('p', '', review.body));
    return card;
  }

  function createReviewMediaCard(review) {
    if (!Array.isArray(review.media) || !review.media.length) return null;
    var card = document.createElement('article');
    card.className = 'bb-review-media-card';
    var gallery = document.createElement('div');
    gallery.className = 'bb-review-media-card__gallery';
    gallery.setAttribute('role', 'group');
    gallery.setAttribute('aria-label', 'Review media gallery');
    var track = document.createElement('div');
    track.className = 'bb-review-media-card__track';
    var slides = [];
    if (Array.isArray(review.media) && review.media.length) {
      review.media.forEach(function (item, mediaIndex) {
        var url = safeMediaUrl(item.url);
        if (!url) return;
        var slide = document.createElement('div');
        slide.className = 'bb-review-media-card__slide';
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-label', 'Media ' + (mediaIndex + 1) + ' of ' + review.media.length);
        var node = item.kind === 'video' ? document.createElement('video') : document.createElement('img');
        node.src = url;
        if (item.kind === 'video') {
          node.controls = false;
          node.playsInline = true;
          node.preload = 'metadata';
          var video = node;
          var play = document.createElement('button');
          play.type = 'button';
          play.className = 'bb-review-media-card__play';
          play.setAttribute('aria-label', 'Play review video');
          play.addEventListener('click', function () {
            video.controls = true;
            video.play().catch(function () {});
          });
          video.addEventListener('play', function () { play.hidden = true; });
          video.addEventListener('pause', function () { play.hidden = false; });
          video.addEventListener('ended', function () { play.hidden = false; });
          slide.appendChild(video);
          slide.appendChild(play);
        } else {
          node.loading = 'lazy';
          node.alt = (review.title || 'Customer review photo') + (review.media.length > 1 ? ' ' + (mediaIndex + 1) : '');
          slide.appendChild(node);
        }
        track.appendChild(slide);
        slides.push(slide);
      });
    }
    if (!slides.length) return null;
    gallery.appendChild(track);

    if (slides.length > 1) {
      gallery.tabIndex = 0;
      var currentSlide = 0;
      var dots = document.createElement('div');
      dots.className = 'bb-review-media-card__dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', 'Choose review media');
      var dotButtons = slides.map(function (_slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Show media ' + (index + 1) + ' of ' + slides.length);
        dots.appendChild(dot);
        return dot;
      });

      function setSlide(index, moveFocus) {
        currentSlide = (index + slides.length) % slides.length;
        track.style.transform = 'translate3d(-' + (currentSlide * 100) + '%, 0, 0)';
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === currentSlide;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
          if (!active) {
            var video = slide.querySelector('video');
            if (video) video.pause();
          }
        });
        dotButtons.forEach(function (dot, dotIndex) {
          var active = dotIndex === currentSlide;
          dot.setAttribute('aria-pressed', active ? 'true' : 'false');
          dot.setAttribute('tabindex', active ? '0' : '-1');
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        if (moveFocus && dotButtons[currentSlide]) dotButtons[currentSlide].focus();
      }

      var previous = document.createElement('button');
      previous.type = 'button';
      previous.className = 'bb-review-media-card__arrow bb-review-media-card__arrow--previous';
      previous.setAttribute('aria-label', 'Previous review media');
      previous.addEventListener('click', function () { setSlide(currentSlide - 1); });
      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'bb-review-media-card__arrow bb-review-media-card__arrow--next';
      next.setAttribute('aria-label', 'Next review media');
      next.addEventListener('click', function () { setSlide(currentSlide + 1); });
      dotButtons.forEach(function (dot, index) {
        dot.addEventListener('click', function () { setSlide(index); });
      });
      gallery.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setSlide(currentSlide - 1, event.target.closest('.bb-review-media-card__dots') !== null);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          setSlide(currentSlide + 1, event.target.closest('.bb-review-media-card__dots') !== null);
        }
      });
      var touchStartX = null;
      gallery.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      gallery.addEventListener('touchend', function (event) {
        if (touchStartX == null) return;
        var distance = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(distance) < 40) return;
        setSlide(currentSlide + (distance < 0 ? 1 : -1));
      }, { passive: true });
      gallery.appendChild(previous);
      gallery.appendChild(next);
      gallery.appendChild(dots);
      setSlide(0);
    } else {
      slides[0].setAttribute('aria-hidden', 'false');
    }

    card.appendChild(gallery);
    card.appendChild(createReviewMeta(review));
    if (review.title) card.appendChild(textNode('h3', '', review.title));
    card.appendChild(textNode('p', 'bb-review-media-card__body', review.body));
    return card;
  }

  function initialise(section) {
    var endpoint = section.dataset.reviewsEndpoint;
    if (!endpoint || !/^\d+$/.test(section.dataset.productId || '')) return;
    var list = section.querySelector('[data-review-list]');
    var empty = section.querySelector('[data-review-empty]');
    var filterEmpty = section.querySelector('[data-review-filter-empty]');
    var error = section.querySelector('[data-review-error]');
    var summary = section.querySelector('[data-review-summary]');
    var toolbar = section.querySelector('[data-review-toolbar]');
    var more = section.querySelector('[data-review-more]');
    var filter = section.querySelector('[data-review-rating-filter]');
    var clearFilter = section.querySelector('[data-review-clear-filter]');
    var sort = section.querySelector('[data-review-sort]');
    var mediaColumn = section.querySelector('[data-review-media-column]');
    var mediaList = section.querySelector('[data-review-media-list]');
    var cursor = null;

    function renderStats(stats) {
      var count = Number(stats.review_count || 0);
      var average = Number(stats.average_rating || 0);
      var averageNode = section.querySelector('[data-review-average]');
      var countNode = section.querySelector('[data-review-count]');
      var breakdown = section.querySelector('[data-review-breakdown]');
      section.classList.toggle('is-empty', count === 0);
      if (averageNode) averageNode.textContent = average.toFixed(1);
      if (countNode) countNode.textContent = count + (count === 1 ? ' review' : ' reviews');
      if (breakdown) {
        breakdown.innerHTML = '';
        [5, 4, 3, 2, 1].forEach(function (rating) {
          var ratingCount = Number(stats['rating_' + rating + '_count'] || 0);
          var row = document.createElement('div');
          row.className = 'bb-reviews__bar';
          row.appendChild(textNode('span', '', rating + ' ★'));
          var track = document.createElement('span');
          track.className = 'bb-reviews__bar-track';
          var fill = document.createElement('span');
          fill.className = 'bb-reviews__bar-fill';
          fill.style.width = (count ? Math.round(ratingCount / count * 100) : 0) + '%';
          track.appendChild(fill);
          row.appendChild(track);
          row.appendChild(textNode('span', '', ratingCount));
          breakdown.appendChild(row);
        });
      }
      summary.hidden = count === 0;
      toolbar.hidden = count === 0;
      empty.hidden = count !== 0;
      if (filterEmpty) filterEmpty.hidden = true;
    }

    function load(append) {
      var params = new URLSearchParams();
      if (filter.value) params.set('rating', filter.value);
      if (sort.value) params.set('sort', sort.value);
      if (append && cursor) params.set('cursor', cursor);
      more.disabled = true;
      more.setAttribute('aria-busy', 'true');
      error.hidden = true;
      if (filterEmpty) filterEmpty.hidden = true;
      return fetch(endpoint + '?' + params.toString(), { headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('Reviews unavailable'); return response.json(); })
        .then(function (data) {
          if (!append) {
            list.innerHTML = '';
            if (mediaList) mediaList.innerHTML = '';
          }
          (data.reviews || []).forEach(function (review) {
            var mediaCard = createReviewMediaCard(review);
            if (mediaList && mediaCard) mediaList.appendChild(mediaCard);
            else list.appendChild(createReviewCard(review));
          });
          if (mediaColumn) mediaColumn.hidden = !mediaList || !mediaList.children.length;
          cursor = data.nextCursor || null;
          more.hidden = !cursor;
          renderStats(data.stats || {});
          if (filter.value && !list.children.length && (!mediaList || !mediaList.children.length)) {
            empty.hidden = true;
            if (filterEmpty) filterEmpty.hidden = false;
          }
        })
        .catch(function () {
          if (!append) list.innerHTML = '';
          if (!append && mediaList) mediaList.innerHTML = '';
          if (mediaColumn) mediaColumn.hidden = true;
          error.hidden = false;
          empty.hidden = true;
          if (filterEmpty) filterEmpty.hidden = true;
          more.hidden = true;
        })
        .finally(function () {
          more.disabled = false;
          more.setAttribute('aria-busy', 'false');
        });
    }

    filter.addEventListener('change', function () { cursor = null; load(false); });
    if (clearFilter) {
      clearFilter.addEventListener('click', function () {
        filter.value = '';
        cursor = null;
        load(false);
      });
    }
    sort.addEventListener('change', function () { cursor = null; load(false); });
    more.addEventListener('click', function () { load(true); });
    load(false);
  }

  document.querySelectorAll('[data-product-reviews]').forEach(initialise);
})();
